import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { iconContainerSize } from "../../hooks/useIcon/index.mjs";
import { IconBolt } from "../icons/IconBolt/IconBolt.mjs";
import { IconClose } from "../icons/IconClose/IconClose.mjs";
import { IconErrorOutline } from "../icons/IconErrorOutline/IconErrorOutline.mjs";
import { IconInfoInverted } from "../icons/IconInfoInverted/IconInfoInverted.mjs";
import { IconPositive } from "../icons/IconPositive/IconPositive.mjs";
import { IconWarningNew } from "../icons/IconWarningNew/IconWarningNew.mjs";
import { Columns } from "../Columns/Columns.mjs";
import { Column } from "../Column/Column.mjs";
import { Overlay } from "../private/Overlay/Overlay.mjs";
import { textAlignedToIcon } from "../../css/textAlignedToIcon.css.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { virtualTouchable } from "../private/touchable/virtualTouchable.mjs";
import { closeButton, closeButtonFocus, closeButtonHover } from "./Alert.css.mjs";
const borderRadius = "large";
const backgroundForTone = {
  promote: "promoteLight",
  info: "infoLight",
  positive: "positiveLight",
  caution: "cautionLight",
  critical: "criticalLight"
};
const borderForTone = {
  promote: "borderPromoteLight",
  info: "borderInfoLight",
  positive: "borderPositiveLight",
  caution: "borderCautionLight",
  critical: "borderCriticalLight"
};
const icons = {
  positive: IconPositive,
  info: IconInfoInverted,
  promote: IconBolt,
  caution: IconWarningNew,
  critical: IconErrorOutline
};
const Alert = ({
  tone = "info",
  children,
  id,
  closeLabel = "Close",
  data,
  onClose,
  ...restProps
}) => {
  const Icon = icons[tone];
  return /* @__PURE__ */ jsxs(
    Box,
    {
      id,
      background: backgroundForTone[tone],
      padding: "small",
      borderRadius,
      position: "relative",
      overflow: "hidden",
      role: "alert",
      "aria-live": "polite",
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: [
        /* @__PURE__ */ jsxs(Columns, { space: "xxsmall", children: [
          /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(Icon, { tone }) }),
          /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(Box, { className: textAlignedToIcon.standard, children }) }),
          onClose ? /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsxs(
            Box,
            {
              component: "button",
              "aria-label": closeLabel,
              borderRadius: "full",
              cursor: "pointer",
              position: "relative",
              onClick: onClose,
              outline: "none",
              transition: "touchable",
              transform: { active: "touchable" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              className: [closeButton, iconContainerSize(), virtualTouchable()],
              children: [
                /* @__PURE__ */ jsx(
                  Overlay,
                  {
                    component: "span",
                    boxShadow: "outlineFocus",
                    transition: "fast",
                    onlyVisibleForKeyboardNavigation: true,
                    borderRadius: "full",
                    className: closeButtonFocus
                  }
                ),
                /* @__PURE__ */ jsx(
                  Overlay,
                  {
                    component: "span",
                    background: "surface",
                    transition: "fast",
                    borderRadius: "full",
                    className: closeButtonHover
                  }
                ),
                /* @__PURE__ */ jsx(Box, { component: "span", display: "block", zIndex: 1, position: "relative", children: /* @__PURE__ */ jsx(IconClose, { size: "fill", tone }) })
              ]
            }
          ) }) : null
        ] }),
        /* @__PURE__ */ jsx(Overlay, { borderRadius, boxShadow: { lightMode: borderForTone[tone] }, visible: true })
      ]
    }
  );
};
export {
  Alert
};
